<div class="topbar clearfix">
    <div class="topbar-left">
        <div class="logo tw-flex tw-w-full tw-mr-2"></div>
        <section class="tw-flex tw-flex-initial tw-items-center">
            <a id="menu-button" class="tw-align-middle tw-text-gray-100 fa-2x fas fa-chevron-circle-left"
                [ngClass]="{ 'active-top-menu': this.configService.menuActive }" href="#"
                (click)="this.configService.onMenuButtonClick($event)">
            </a>
        </section>
    </div>

    <div class="topbar-middle">
        <div #searchMiddle class="search-item tw-flex tw-justify-center" [ngClass]="{
                'active-top-menu':
                    layoutService.currentLayout$?.value?.activeTopbarItem ===
                    searchMiddle
            }" (click)="
                layoutService.currentLayout$?.value?.onTopbarItemClick(
                    $event,
                    searchMiddle
                )
            ">
            <section class="tw-flex tw-basis-[70%] tw-mt-2">
                <app-search-bar [config]="this.searchBarConfig"></app-search-bar>
            </section>
        </div>
    </div>

    <div class="topbar-right">
        <a id="topbar-menu-button" href="#" (click)="
                layoutService.currentLayout$?.value?.onTopbarMenuButtonClick(
                    $event
                )
            ">
            <em class="material-icons">menu</em>
        </a>

        <ul class="topbar-items animated fadeInDown" style="padding: 0">

            <li #profile class="profile-item" *ngIf="
                    layoutService.currentLayout$?.value?.profileMode ===
                        'top' ||
                    layoutService.currentLayout$?.value?.service
                        .isHorizontalMenu
                " [ngClass]="{
                    'active-top-menu':
                        layoutService.currentLayout$?.value
                            ?.activeTopbarItem === profile
                }">
                <a href="#" (click)="
                        layoutService.currentLayout$?.value?.onTopbarItemClick(
                            $event,
                            profile
                        )
                    ">
                    <section class="user-name tw-flex tw-flex-col tw-flex-center">
                        <label class="">{{
                            (userInfo$ | async)?.fullName
                            }}</label>
                        <label class="tw-text-sm tw-text-gray-300">{{
                            currentRoleName
                            }}</label>
                    </section>

                    <span class="user-initials profile-image" fxFlex="auto" fxFlexAlign="center">
                        {{ (userInfo$ | async)?.userInitials() }}
                    </span>
                </a>

                <ul class="ultima-menu animated fadeInDown">
                    <li role="menuitem">
                        <a href="javascript:void(0);" (click)="toggleRightPanelUserSettings()">
                            <em class="fal fa-cog"></em>
                            <span>Settings</span>
                        </a>
                    </li>
                    <li role="menuitem" *ngIf="this.featureService.activated">
                        <a href="javascript:void(0);" (click)="this.toggleRightPanelPreviewFeatures()">
                            <em class="fal fa-vials"></em>
                            <span>Features</span>
                        </a>
                    </li>
                    <li role="menuitem">
                        <a href="#" (click)="this.userService.logout()">
                            <em class="fal fa-sign-out"></em>
                            <span>Logout</span>
                        </a>
                    </li>
                    <li role="menuitem" style="position: absolute; right: 7px; top: -3px" fxLayoutAlign="end center">
                        <em><sub>{{ appVersion }}</sub></em>
                    </li>
                </ul>
            </li>

            <li style="margin-top: 8px;" #profile class="profile-item" *ngIf="
                    layoutService.currentLayout$?.value?.profileMode ===
                        'top' ||
                    layoutService.currentLayout$?.value?.service
                        .isHorizontalMenu
                " [ngClass]="{
                    'active-top-menu':
                        layoutService.currentLayout$?.value
                            ?.activeTopbarItem === profile
                }">
                <span class="user-name clickable-icon badge-hover" (click)="handleMyViewClick()">
                    <i [className]="this.userViewIcon" pBadge style="
                    font-size: 1.5rem;
                    margin-right: 1.4rem;
                    margin-top: 0.6rem;
                " [value]="this.viewsCount" severity="danger" pTooltip="My Views" tooltipPosition="top" [ngClass]="{
                    'text-white tw-text-opacity-[60]':
                        this.notificationIcon,
                    'text-red-700': !this.viewsCount
                }">
                    </i>
                </span>
                <span class="user-name clickable-icon badge-hover" (click)="handleMessagesClick()">
                    <i [className]="this.notificationIcon" pBadge style="
                            font-size: 1.5rem;
                            margin-right: 1.4rem;
                            margin-top: 0.6rem;
                        " [value]="notifications" severity="danger" pTooltip="Notifications" tooltipPosition="top"
                        [ngClass]="{
                            'text-white tw-text-opacity-[60]':
                                this.notificationIcon,
                            'text-red-700': !this.notificationIcon
                        }">
                    </i>
                </span>
            </li>
        </ul>
    </div>
</div>
